﻿import type { RouteRecordRaw } from 'vue-router'

const inventoryRoutes: RouteRecordRaw = {
  path: '/inventory',
  name: 'Inventory',
  redirect: '/inventory/ledger',
  meta: { title: '库存核算', icon: 'icon-storage' },
  children: [
    {
      path: 'inout',
      name: 'InventoryInOut',
      component: () => import('@/views/inventory/DocSummary.vue'),
      meta: { title: '出入库单据', doctype: '', source: 'all', permissions: ['inventory:inout:view'] },
    },
    {
      path: 'stock-entry',
      name: 'InventoryStockEntry',
      component: () => import('@/views/inventory/InOutList.vue'),
      meta: { title: '库存单据', permissions: ['inventory:inout:view'] },
    },
    {
      path: 'fg-in',
      name: 'InventoryFgIn',
      component: () => import('@/views/inventory/DocSummary.vue'),
      meta: { title: '产成品入库单', doctype: 'Stock Entry', stockEntryType: 'Manufacture', source: 'stock_entry', permissions: ['inventory:inout:view'] },
    },
    {
      path: 'other-in',
      name: 'InventoryOtherIn',
      component: () => import('@/views/inventory/DocSummary.vue'),
      meta: { title: '其他入库单', doctype: 'Stock Entry', stockEntryType: 'Material Receipt', source: 'stock_entry', permissions: ['inventory:inout:view'] },
    },
    {
      path: 'material-out',
      name: 'InventoryMaterialOut',
      component: () => import('@/views/inventory/DocSummary.vue'),
      meta: { title: '材料出库单', doctype: 'Stock Entry', stockEntryType: 'Material Transfer for Manufacture', source: 'stock_entry', permissions: ['inventory:inout:view'] },
    },
    {
      path: 'other-out',
      name: 'InventoryOtherOut',
      component: () => import('@/views/inventory/DocSummary.vue'),
      meta: { title: '其他出库单', doctype: 'Stock Entry', stockEntryType: 'Material Issue', source: 'stock_entry', permissions: ['inventory:inout:view'] },
    },
    {
      path: 'transfer',
      name: 'InventoryTransfer',
      component: () => import('@/views/inventory/DocSummary.vue'),
      meta: { title: '调拨单', doctype: 'Stock Entry', stockEntryType: 'Material Transfer', source: 'stock_entry', permissions: ['inventory:inout:view'] },
    },
    {
      path: 'ledger',
      name: 'InventoryLedger',
      component: () => import('@/views/inventory/LedgerList.vue'),
      meta: { title: '存货明细账', permissions: ['inventory:ledger:view'] },
    },
    {
      path: 'balance',
      name: 'InventoryBalance',
      component: () => import('@/views/inventory/StockBalanceList.vue'),
      meta: { title: '存货总账', permissions: ['inventory:ledger:view'] },
    },
    {
      path: 'purchase-check',
      name: 'InventoryPurchaseCheck',
      component: () => import('@/views/inventory/PurchaseCheckList.vue'),
      meta: { title: '采购核算单', permissions: ['inventory:report:view'] },
    },
    {
      path: 'adjust',
      name: 'InventoryAdjust',
      component: () => import('@/views/inventory/AdjustList.vue'),
      meta: { title: '库存调整单', permissions: ['inventory:report:view'] },
    },
    {
      path: 'repost',
      name: 'InventoryRepost',
      component: () => import('@/views/inventory/RepostList.vue'),
      meta: { title: '重新计价', permissions: ['inventory:report:view'] },
    },
    {
      path: 'wo-cost',
      name: 'InventoryWoCost',
      component: () => import('@/views/inventory/WorkOrderCostList.vue'),
      meta: { title: '产品成本分配明细表', permissions: ['inventory:report:view'] },
    },
    {
      path: 'material-alloc',
      name: 'InventoryMaterialAlloc',
      component: () => import('@/views/inventory/MaterialAllocList.vue'),
      meta: { title: '直接材料分配明细表', permissions: ['inventory:report:view'] },
    },
    {
      path: 'check',
      name: 'InventoryCheck',
      component: () => import('@/views/inventory/CheckList.vue'),
      meta: { title: '盘点单', permissions: ['inventory:check:view'] },
    },
  ],
}

export default inventoryRoutes
